import * as React from 'react';
export var SocialIconApple = function SocialIconApple() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "22",
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.399 3.412c.539-.652.92-1.55.92-2.449 0-.123-.01-.247-.033-.348C10.41.65 9.343 1.2 8.714 1.94c-.505.573-.966 1.472-.966 2.381 0 .135.023.27.034.315.056.011.146.022.236.022.797 0 1.797-.528 2.38-1.246zm.617 1.437l.133.002c.635.014 2.257.17 3.349 1.75l-.209.14c-.496.352-1.69 1.356-1.69 3.196 0 2.605 2.28 3.526 2.348 3.548l-.026.095a9.453 9.453 0 0 1-1.176 2.399l-.236.34c-.677.955-1.428 1.827-2.493 1.827-1.19 0-1.505-.708-2.875-.708-1.347 0-1.819.73-2.908.73-1.09 0-1.853-1.01-2.73-2.234-1.01-1.45-1.83-3.684-1.83-5.818 0-3.403 2.212-5.222 4.402-5.222 1.157 0 2.123.764 2.853.764.685 0 1.763-.809 3.088-.809z",
    fillRule: "nonzero"
  }));
};